export default "__VITE_ASSET__da4e1c7a__"